import React, {useEffect, useState} from 'react'
import {withRouter} from "react-router";
import SiwzDocuments from "./swz/SiwzDocuments";
import RepoDocuments from "./repo/RepoDocuments";
import RepoService from "services/RepoService";
import SiwzService from "services/SiwzService";
import Loading from "components/Loading";
import PropTypes from "prop-types";

function DocumentsTables(
    {
        demandId,
        siwzEditable,
        repoEditable
    }) {

    const [documentsLoading, setDocumentsLoading] = useState(true);

    useEffect(() => {
        const siwzListPromise = SiwzService.getList(demandId);
        const siwzTypesPromise = SiwzService.getTypes(demandId);
        const repoFolderListPromise = RepoService.getList(demandId);
        const repoVsibilityTypesPromise = RepoService.getVisibilityTypes(demandId);
        Promise.all([siwzListPromise, siwzTypesPromise, repoFolderListPromise, repoVsibilityTypesPromise])
            .then(() => setDocumentsLoading(false));

        return () => {
            RepoService.clearResources(RepoService.FOLDER_LIST_RESOURCE_ID);
            RepoService.clearResources(RepoService.VISIBILITY_TYPES_RESOURCE_ID);
            SiwzService.clearResources(SiwzService.SIWZ_LIST_RESOURCE_ID);
            SiwzService.clearResources(SiwzService.SIWZ_TYPE_LIST_RESOURCE_ID);
        }
    }, [demandId]);

    if (documentsLoading) return <Loading/>
    return (<>
        <SiwzDocuments editable={siwzEditable} demandId={demandId}/>
        <RepoDocuments editable={repoEditable} demandId={demandId}/>
    </>)
}

DocumentsTables.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    siwzEditable: PropTypes.bool.isRequired,
    repoEditable: PropTypes.bool.isRequired
}

export default withRouter(DocumentsTables);